/** @typedef {'R' | 'A' | 'C' | 'I'} RaciValue */

export const RACI_VALUES = ['R', 'A', 'C', 'I'];

export const RACI_INFO_INTRO =
    'A RACI chart, or responsibility assignment matrix, is a project management tool that defines and clarifies roles and responsibilities within a project team. RACI charts categorize these roles into four components: Responsible, Accountable, Consulted, and Informed. It helps establish clear communication, improve decision-making, and ensure accountability for tasks or deliverables.';

export const RACI_ROLE_DEFINITIONS = [
    {
        term: 'Responsible',
        description:
            'The responsible individual is delegated a responsibility from the accountable person and must complete that responsibility within agreed-upon parameters and an agreed-upon deadline. A task may have more than one responsible individual.',
    },
    {
        term: 'Accountable',
        description:
            'The accountable individual ensures that all the responsible members complete the task. Accountabilities should not be delegated; it is best to assign the task to a single individual who can serve as the decision-maker and guide.',
    },
    {
        term: 'Consulted',
        description:
            "The consulted individual is the team's knowledge-holder. They're available for help, extra context, and advice on the task. Identify these people early on so you can incorporate them into the project and its workflow.",
    },
    {
        term: 'Informed',
        description:
            "The informed party is typically a stakeholder, leadership team, or approver who wants and needs information about the team's project. Ensuring there is an informed party promotes internal transparency, team alignment, and accurate project timelines.",
    },
];

export const ACTIVITY_COLUMN_MIN_WIDTH = 280;
export const STAKEHOLDER_COLUMN_WIDTH = 200;

export const createId = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `raci-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
};
